module.exports = __webpack_public_path__ + "static/media/project-cups.c6416038.jpg";